/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsTagsSystem extends models.RecommendationBaseForFinOps {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsTagsSystem");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsTagsSystem.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsTagsSystem>): RecommendationForFinopsTagsSystem {
        let obj = Object.assign(new RecommendationForFinopsTagsSystem(), model);
        RecommendationForFinopsTagsSystem.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsTagsSystem>): RecommendationForFinopsTagsSystem {
        if (!model) return null;
        return RecommendationForFinopsTagsSystem.newInstance(<RecommendationForFinopsTagsSystem> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsTagsSystem) {
        if (!obj) return;

        models.RecommendationForFinopsTagsSystem.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsTagsSystem): boolean {
        if (models.RecommendationBaseForFinOps.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsTagsSystem.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
